import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./App";
import AuthProvider from "./store/auth/auth-provider";
import SeatsProvider from "./store/seats/seats-provider";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';


if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <AuthProvider>
    <SeatsProvider>
      <App />
    </SeatsProvider>
  </AuthProvider>
);
